import React, { Component } from 'react'
import { observer } from 'mobx-react'
import * as R from 'ramda'
import Question from '../../../frontend/app/components/Question'

import './questionPreview.scss'

@observer
class QuestionPreview extends Component {
    constructor(props) {
        super(props)
        this.question = JSON.parse(JSON.stringify(props.question))
        this.question.validator = { options: new Map() }
    }

    componentDidMount() {
        const { isLite } = this.props
        const sbElement = document.querySelector('.questionbody .SB')
        if (sbElement && isLite) {
            sbElement.style.pointerEvents = 'none'
        }
    }

    previewStore = () => {
        const { store } = this.props

        return {
            form_data: new Map(),
            langcode: store.surveyLocale,
            getOptionTitle: (option, question) => {
                const { surveyLocale } = store
                const { initialLocale } = question.metadata
                const { defaultLocale } = store.survey.metadata
                if (R.pathOr('', ['text'], option.langs[surveyLocale])) {
                    return R.pathOr('', ['text'], option.langs[surveyLocale])
                }

                if (R.pathOr('', ['text'], option.langs[defaultLocale])) {
                    return R.pathOr('', ['text'], option.langs[defaultLocale])
                }

                return R.pathOr('', ['text'], option.langs[initialLocale])
            },
            priorityClickCounters: {},
            addFormResponse: () => { },
            questionLogicUpdated: {},
            data: { metadata: { defaultLocale: 'en_GB' }, currencyOptions: [] },
            replaceOptionMerge: (text) => (text),
            displayForMobile: () => (this.question.questionTypeCode === 'OD'),
            prePostFix: (question, fix) => {
                const { surveyLocale } = store
                const { initialLocale } = question.metadata
                const { defaultLocale } = store.survey.metadata
                if (R.pathOr('', ['settings', 'frontend', fix, surveyLocale], question)) {
                    return R.pathOr('', ['settings', 'frontend', fix, surveyLocale], question)
                }

                if (R.pathOr('', ['settings', 'frontend', fix, defaultLocale], question)) {
                    return R.pathOr('', ['settings', 'frontend', fix, defaultLocale], question)
                }

                return R.pathOr('', ['settings', 'frontend', fix, initialLocale])(question)
            },
            addNFCurrencyResponse: () => { },
        }
    }

    render() {
        const { question, styles } = this.props
        return (
            <div className="questionPreview">
                <div className="surveypage">
                    <form ref="form" id="surveypage" data-id={question.id}>
                        <div className="questionPreview" style={styles}>
                            <Question
                                question={this.question}
                                key="test"
                                store={this.previewStore()}
                            />
                        </div>
                    </form>
                </div>
            </div>
        )
    }
}

export default QuestionPreview
